/** GxSparkline: last point ringed, an optional dashed reference line (a median or a floor). Decorative; the tile carries the value. */
export function GxSparkline({ values, color, reference, width = 64, height = 32 }: {
  readonly values: readonly number[]; readonly color: string; readonly reference?: number; readonly width?: number; readonly height?: number;
}) {
  const pad = 3;
  const all = reference === undefined ? values : [...values, reference];
  let lo = Math.min(...all);
  let hi = Math.max(...all);
  const span = hi - lo || 1;
  lo -= span * 0.15;
  hi += span * 0.15;
  const x = (i: number) => pad + (i / (values.length - 1)) * (width - 2 * pad);
  const y = (v: number) => height - pad - ((v - lo) / (hi - lo)) * (height - 2 * pad);
  const line = values.map((v, i) => `${i === 0 ? "M" : "L"}${x(i).toFixed(1)},${y(v).toFixed(1)}`).join(" ");
  const last = values.length - 1;
  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} aria-hidden="true" style={{ flex: "none" }}>
      {reference === undefined ? null : <line x1="0" x2={width} y1={y(reference)} y2={y(reference)} stroke="var(--border-strong)" strokeDasharray="2 3" />}
      <path d={`${line} L${x(last).toFixed(1)},${height} L${x(0).toFixed(1)},${height} Z`} fill={color} opacity=".08" />
      <path d={line} fill="none" stroke={color} strokeWidth="1.75" strokeLinejoin="round" strokeLinecap="round" />
      <circle cx={x(last)} cy={y(values[last] ?? 0)} r="2.75" fill="var(--surface)" stroke={color} strokeWidth="1.75" />
    </svg>
  );
}
